var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "article-list"
  }, [_c('div', {
    staticClass: "flex gap-5 justify-between items-end mb-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex w-full gap-5 mdmax:w-full mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-full max-w-lg mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari artikel..."
    },
    on: {
      "enter": _vm.onSearch
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])]), _c('div', [_c('button', {
    staticClass: "px-2 py-2 w-32 bg-primary-500 text-white rounded-lg font-medium hover:bg-primary-600 transition-colors",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/article/create');
      }
    }
  }, [_vm._v(" + Add Artikel ")])])]), _c('div', {
    staticClass: "bg-white rounded-lg shadow-sm overflow-hidden"
  }, [_c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "w-full text-left border-collapse"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "text-neutral-700 text-sm"
  }, [_vm._l(_vm.items, function (article, index) {
    return _c('tr', {
      key: article.id,
      staticClass: "border-b border-neutral-100 hover:bg-neutral-50 transition-colors"
    }, [_c('td', {
      staticClass: "p-4"
    }, [_vm._v(_vm._s((_vm.page - 1) * _vm.limit + index + 1))]), _c('td', {
      staticClass: "p-4 font-medium"
    }, [_vm._v(_vm._s(article.title))]), _c('td', {
      staticClass: "p-4 w-1/3"
    }, [_c('div', {
      staticClass: "truncate max-w-xs",
      attrs: {
        "title": article.sort_description
      }
    }, [_vm._v(" " + _vm._s(article.sort_description) + " ")])]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(article.created_at)) + " ")]), _c('td', {
      staticClass: "p-4"
    }, [_c('span', {
      staticClass: "px-2 py-1 rounded text-xs font-medium capitalize",
      class: _vm.statusClass(article.status)
    }, [_vm._v(" " + _vm._s(article.status) + " ")])]), _c('td', {
      staticClass: "p-4"
    }, [_c('div', {
      staticClass: "flex items-center gap-3"
    }, [_c('button', {
      staticClass: "text-neutral-500 hover:text-primary-500 transition-colors",
      on: {
        "click": function ($event) {
          return _vm.onEdit(article);
        }
      }
    }, [_c('Pencil', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1), _c('button', {
      staticClass: "text-neutral-500 hover:text-red-500 transition-colors",
      on: {
        "click": function ($event) {
          return _vm.onDelete(article);
        }
      }
    }, [_c('Trash', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1)])])]);
  }), !_vm.items || _vm.items.length === 0 ? _c('tr', [_c('td', {
    staticClass: "p-4 text-center text-neutral-500",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" Data tidak ditemukan! ")])]) : _vm._e()], 2)])])]), !_vm.isMobile && _vm.items.length > 0 ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" Menampilkan " + _vm._s((_vm.page - 1) * _vm.limit + 1) + " - " + _vm._s(Math.min(_vm.page * _vm.limit, _vm.meta.total_item)) + " dari " + _vm._s(_vm.meta.total_item) + " ")]) : _vm._e(), _vm.items.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.page,
      "totalCount": _vm.meta.total_item,
      "pageSize": _vm.limit
    },
    on: {
      "onPageChange": _vm.changePage
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Hapus Artikel")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v("Apakah Anda yakin ingin menghapus artikel "), _c('strong', [_vm._v(_vm._s(_vm.articleToDelete ? _vm.articleToDelete.title : ''))]), _vm._v("?")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v(" Hapus ")])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', {
    staticClass: "bg-neutral-50 text-neutral-500 text-sm font-semibold border-b border-neutral-200"
  }, [_c('th', {
    staticClass: "p-4"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Judul")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Deskripsi Singkat")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Tanggal Dibuat")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Action")])])]);

}]

export { render, staticRenderFns }